export default "__VITE_ASSET__gCOfde0B__"